export default "__VITE_ASSET__BFGYr4Kr__"